module.exports = __webpack_public_path__ + "img/thunfischfront.c91858c8.png";